import React from 'react'
import PropTypes from 'prop-types'

import SubmissionCategories from './SubmissionCategories'

function SubmissionCategoriesContainer({
  categories, activeCategory, onCategoryChange, showError,
}) {
  return (
    <div className="row form-group">
      <div className="col-12">
        <label className="category-title">Select category <b>*</b></label>
      </div>
      {categories.map((category) => (
        <div className="col-6 category-container" key={category.title}>
          <p className="category-title">{category.title}</p>
          <div className="row">
            <div className="col-12 category-right-border">
              <SubmissionCategories
                buttons={category.buttons}
                activeCategory={activeCategory}
                onCategoryChange={onCategoryChange}
              />
            </div>
          </div>
        </div>
      ))}
      {activeCategory === '' && showError === true
        && (
        <div className="col-12 error-message">
          <span className="text">You have to select a category.</span>
        </div>
        )
      }
    </div>
  )
}

SubmissionCategoriesContainer.propTypes = {
  categories: PropTypes.array.isRequired,
  onCategoryChange: PropTypes.func.isRequired,
  activeCategory: PropTypes.string,
  showError: PropTypes.bool.isRequired,
}

SubmissionCategoriesContainer.defaultPropTypes = {
  activeCategory: '',
}

export default SubmissionCategoriesContainer
